import authService from "../../../auth/AuthService";
import {approvalsActionTypes} from "../constants/UtilityMiddlewareConstants";

const setApprovalForResource = ({type, approvalsObject, authToken}) => ({
    type: approvalsActionTypes.SET_APPROVAL,
    payload: {type, approvalsObject, authToken}
});

const removeApprovalForResource = ({type, approvalsObject, authToken}) => ({
    type: approvalsActionTypes.REMOVE_APPROVAL,
    payload: {type, approvalsObject, authToken}
});

/**
 *
 * @param type, one of 'dp, dpService, dpSource'
 * @param approvalsObject
 * This function has a check and according to the approval-value dispatches the right action to either
 * set or reset the approval record of the underlying resource-id in the approvalsObject.
 * @returns {function(*): Promise<undefined>}
 */
export function toggleApproval(type, approvalsObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        approvalsObject.is_approved
            ? dispatch(removeApprovalForResource({type, approvalsObject, authToken}))
            : dispatch(setApprovalForResource({type, approvalsObject, authToken}))
    }
}



